import { forwardRef } from 'react';
import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile';

/** Cloudflare Turnstile mount for the shop's public forms. FAIL-CLOSED: when
 *  no site key is baked in (VITE_TURNSTILE_SITE_KEY), the widget renders
 *  nothing and the caller keeps its submit disabled — a form that can't be
 *  verified must not submit. */
const SITE_KEY =
  (import.meta.env['VITE_TURNSTILE_SITE_KEY'] as string | undefined) || undefined;

export const hasTurnstile = Boolean(SITE_KEY);

export const ShopTurnstile = forwardRef<
  TurnstileInstance,
  { onToken: (t: string | null) => void }
>(function ShopTurnstile({ onToken }, ref) {
  if (!SITE_KEY) return null;
  return (
    <Turnstile
      ref={ref}
      siteKey={SITE_KEY}
      onSuccess={(t) => onToken(t)}
      onError={() => onToken(null)}
      onExpire={() => onToken(null)}
      options={{ theme: 'auto', size: 'normal' }}
    />
  );
});
